<template>
    <div class="auth-page">
        <b-container>
            <h5 class="auth-logo">
                <i class="fa fa-circle text-gray"></i>
                Starchase
                <i class="fa fa-circle text-warning"></i>
            </h5>
            <Widget class="widget-auth mx-auto" title="<h3 class='mt-0'>Login to Starchase</h3>" customHeader>
                <p class="widget-auth-info">
                    Use your email to sign in.
                </p>
                <form class="mt" @submit.prevent="login">
                    <b-alert class="alert-sm" variant="danger" :show="!!errorMessage">
                        {{errorMessage}}
                    </b-alert>
                    <div class="form-group">
                        <input class="form-control no-border" ref="username" required type="email" name="email" placeholder="Email" />
                    </div>
                    <div class="form-group">
                        <input class="form-control no-border" ref="password" required type="password" name="password" placeholder="Password" />
                    </div>
                    <b-button type="submit" size="sm" class="auth-btn mb-3" variant="inverse">{{this.isFetching ? 'Loading...' : 'Login'}}</b-button>
                </form>
                <!--        <router-link class="d-block text-center" to="register">Create an Account</router-link>-->
            </Widget>
        </b-container>
    </div>
</template>

<script>
    import Widget from '@/components/Widget/Widget';
    import {mapState, mapActions} from 'vuex';

    export default {
        name: 'LoginPage',
        components: { Widget },
        computed: {
            ...mapState('auth', {
                isFetching: state => state.isFetching,
                errorMessage: state => state.errorMessage,
            }),
        },
        methods: {
            ...mapActions('auth', ['loginUser', 'receiveToken', 'receiveLogin']),
            login() {
                const username = this.$refs.username.value;
                const password = this.$refs.password.value;

                // this.$router.push('/app/content/behaviours');

                if (username.length !== 0 && password.length !== 0) {
                    this.loginUser({username, password});
                }
            },
        },
        created() {
            const token = this.$route.query.token;
            if (token) {
                this.receiveToken(token);
            } else if (this.isAuthenticated(localStorage.getItem('token'))) {
                this.receiveLogin();
            }
        },
        mounted() {
        }
    };
</script>
